<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h3>Search Corporate Customers</h3>
    </v-flex>
    <v-layout xs12 pt-2 class="search-fields" column v-on:keyup.enter="search">
      <v-text-field v-model="query.search" label="Search"></v-text-field>
      <v-btn @click="search" color="blue" dark class="text-none">Search</v-btn>
    </v-layout>
    <v-layout pt-2 column>
      <router-link to="/corporateCustomers/create">
        <h4>Register Corporate Customer</h4>
      </router-link>
      <router-link to="/account_invoicing_policies">
        <h4>Seperate Account Invoicing</h4>
      </router-link>
      <router-link to="/export_account_trips">
        <h4>Export Account Trips</h4>
      </router-link>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: "corporate_customer_search_box",
  props: {
    query: Object
  },
  data: function() {
    return {};
  },
  methods: {
    fromChanged: function(d) {
      this.query.after = d;
    },
    toChanged: function(d) {
      this.query.before = d;
    },
    search: function() {
      this.$emit("search");
    },
    clear: function() {
      this.$emit("clear");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}
</style>
